import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';

/**
 * Persistent application chrome.
 * This component is intentionally mounted outside <Routes> so route changes
 * can never unmount the desktop sidebar/topbar. Only the mobile drawer state
 * changes when navigation occurs.
 */
const AdminChrome = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (typeof window !== 'undefined' && window.matchMedia('(max-width: 900px)').matches) {
      setSidebarOpen(false);
    }
  }, [location.pathname, location.search]);

  return (
    <>
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <Header onMenu={() => setSidebarOpen(true)} />
    </>
  );
};

export default React.memo(AdminChrome);